import { createSelector, createFeatureSelector } from '@ngrx/store';

import { SalesOrderPeriodState } from '../models/sales-order-period.models';

export const selectSalesOrderPeriodState =
  createFeatureSelector<SalesOrderPeriodState>('salesOrderPeriod');
export const selectSalesOrderPeriods = createSelector(
  selectSalesOrderPeriodState,
  (state) => state?.salesOrderPeriods ?? [],
);
